import { render } from "./blank.vue?vue&type=template&id=d18ec276&scoped=true&ts=true&lang=pug"
import script from "./blank.vue?vue&type=script&lang=ts"
export * from "./blank.vue?vue&type=script&lang=ts"

import "./blank.vue?vue&type=style&index=0&id=d18ec276&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d18ec276"]])

export default __exports__